import * as React from 'react';
import { ContractErrorSearch } from 'src/contract-error/_components/contract-error-search/contract-error-search.container';

class ContractErrorComponent extends React.Component {
  render() {
    return (
      <>
        <div className="row middle-xs center-xs">
          <div className="col-md-8 mb-10 pb-10">
            <ContractErrorSearch />
          </div>
        </div>
      </>
    );
  }
}

export default ContractErrorComponent;



// WEBPACK FOOTER //
// ./src/contract-error/_components/contract-error.tsx